import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Trash2, PenLine } from "lucide-react";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { DeleteConfirmDialog } from "@/components/dialog/staff-manage/all-staff-dialog";
import { useSelector } from "react-redux";
import API from "@/api/lib/api";
import { Switch } from "@/components/ui/switch";
import AddEditRoom from "./AddEditRoom";
import hasPermission from "@/hooks/hasPermission";

function RoomList({ data, floors, onRefresh, formType, setFormType }) {  
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [itemsDialog, setItemsDialog] = useState(null);

  const { deleteLoading, requestStatus, error } = useSelector(
    (state) => state.menuManage.drink
  );

  const [isSingleVoucherModalOpen, setIsSingleVoucherModalOpen] = useState(false);
  const closeSingleVoucher = () => {
    setIsSingleVoucherModalOpen(false); 
  };

  const closeDeleteDialog = () => {
    setDeleteDialog(false);
    setItemsDialog(null);
  };

  const deleteHandler = async (id) => {
    try {
      if (!id) {
        toast.error("ID is required to delete.");
        return;
      }
      await API.delete(`restaurant/rooms/${id}`);
      onRefresh();
      toast.success('Deleted successfully')
    } catch (error) {
      toast.error(error.message || "Something went wrong!.");
    } finally {
      closeDeleteDialog();
    }
  };

  const handleToggle = async(id) => {
    try {
      const response = await API.put(
        `restaurant/rooms/${id}/update-status`
      );
      toast.success('Status updated successfully')
      onRefresh();
      return response.data;
    } catch (error) {    
      return (
         error.response?.data || {
          status: "failure",
          message: "Something went wrong.",
        }
      );
    }
  }

  return (
    <>
      <Table className="w-full">
        <TableHeader>
          <TableRow>
            <TableHead className="w-[100px]">No</TableHead>
            <TableHead>Room Number / Name</TableHead>
            <TableHead>Floor</TableHead>
            <TableHead>Status</TableHead>
            <TableHead className="text-right">Action</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data && data?.length > 0 ? (
            data?.map((item, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium">{index +1}</TableCell>
                <TableCell>{item?.name}</TableCell>
                <TableCell>{item?.floor.name}</TableCell>
                <TableCell>
                  <Switch 
                    checked={item?.status === 'active'} 
                    disabled={!hasPermission("back_office.settings.room_status_toggle")}
                    onClick={()=> handleToggle(item?.id)}
                  />
                </TableCell>
                <TableCell className="text-right justify-end flex gap-2 items-center">
                  <div className="flex items-center gap-2 h-8">
                    {hasPermission("back_office.settings.room_update") && (
                      <span className="cursor-pointer">
                        <PenLine
                          onClick={() => {
                            setItemsDialog(item);
                            setFormType('update')
                            setIsSingleVoucherModalOpen(true)
                          }}
                          className="text-cyellow"
                          size={18}
                        />
                      </span>
                    )}

                    {hasPermission("back_office.settings.room_delete") && (
                      <span>
                        <Trash2
                          onClick={() => {
                            setDeleteDialog(true);
                            setItemsDialog(item);
                          }}
                          className="text-cred cursor-pointer"
                          size={18}
                        />
                      </span>
                    )}
                  </div>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={8} className="text-center">
                No data available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <AddEditRoom 
        isOpen={isSingleVoucherModalOpen}
        onClose={closeSingleVoucher}
        floors={floors}
        formType={formType}
        itemsDialog={itemsDialog}
        onRefresh={onRefresh}
      />
      {/* dialog */}
      <DeleteConfirmDialog
        isLoading={deleteLoading}
        isOpen={deleteDialog}
        onClose={closeDeleteDialog}
        onConfirm={() => {
          deleteHandler(itemsDialog.id);
        }}
      />
    </>
  );
}

export default RoomList;
